import React from "react";
import { icon, label, number } from "../../../config";
import { getSortIcon, handleSort } from "./queue.helper";
import { useSelector } from "react-redux";
import { Tooltip } from "@progress/kendo-react-tooltip";

/**
 * Queue team table component for displaying team information
 * @author Bhavana
 */
const QueueTeamTable = ({ index, details, sortedDetails, showMore, RoleId, queueCardHook }) => {
  const {
    // State
    sortConfigs,
    setSortConfigs,
    openMovePopup,
    setOpenMovePopup,
    setQueue,
    hoveredTableRow,
    setHoveredTableRow,
    moveIconRefs,

    // Handlers
    handleProjectClick,
    changeTeamTaskView,
  } = queueCardHook;

  const user = useSelector((state) => state?.auth?.user);
  /**
   * Initialize move reference for a specific team
   * @author Bhavana
   */
  const initializeMoveRef = (moveRefKey) => {
    if (!moveIconRefs.current[moveRefKey]) {
      moveIconRefs.current[moveRefKey] = React.createRef();
    }
  };

  return (
    <div className={`queue-team-table-wrap ${showMore?.includes(index) ? "table-container" : ""} mt-3`}>
      <table className='queue-team-table'>
        <thead>
          <tr>
            <th className='cursor-pointer grey' onClick={() => handleSort("ProjectName", index, sortConfigs, setSortConfigs)}>
              {user?.operationalTeamName} {getSortIcon("ProjectName", index, sortConfigs)}
            </th>
            <th className='cursor-pointer grey' onClick={() => handleSort("members", index, sortConfigs, setSortConfigs)}>
              {label?.MEMBERS} {getSortIcon("members", index, sortConfigs)}
            </th>
            <th className='cursor-pointer grey' onClick={() => handleSort("taskCount", index, sortConfigs, setSortConfigs)}>
              {label?.BREADCRUMB_TASKS} {getSortIcon("taskCount", index, sortConfigs)}
            </th>
          </tr>
        </thead>
        <tbody>
          {sortedDetails?.slice(number.ZERO, showMore?.includes(index) ? sortedDetails?.length : number.THREE)?.map((team, ti) => {
            const moveRefKey = `${index}-${ti}`;
            initializeMoveRef(moveRefKey);

            return (
              <tr className='cursor-pointer queue-team-row' key={ti} onMouseEnter={() => setHoveredTableRow(`${index}-${ti}`)} onMouseLeave={() => setHoveredTableRow(null)}>
                <td
                  onClick={() => handleProjectClick(team)}
                  className='blue queue-team-project-cell'
                  title={`${team?.ProjectName ?? ""} (${team?.ProjectCode ?? ""})`}>
                  {team?.ProjectName} ({team?.ProjectCode})
                </td>
                <td className='text-truncate blue' onClick={() => handleProjectClick(team)}>
                  {team?.members}
                </td>
                <td className='text-truncate queue-team-tasks-cell' onClick={() => handleProjectClick(team)}>
                  <span className='queue-team-task-count blue'>{team?.taskCount}</span>
                  {(hoveredTableRow === `${index}-${ti}` || (openMovePopup?.index === index && openMovePopup?.teamIndex === ti)) && (
                    <Tooltip anchorElement='target' parentTitle={true} position='bottom'>
                    <div className='queue-team-actions'>
                      <span className='mr-2 queue-team-icon' title='View Tasks' onClick={(e) => { e.stopPropagation(); changeTeamTaskView(team); }}>
                        {icon?.TASKS}
                      </span>
                      {RoleId === number.TWO && (
                        <span
                          className='queue-team-icon'
                          title='Move to another workspace'
                          ref={moveIconRefs.current[moveRefKey]}
                          onClick={(e) => {
                            e.stopPropagation();
                            setOpenMovePopup({ index, teamIndex: ti });
                            setQueue({});
                          }}>
                          {icon?.TRANSFER}
                        </span>
                      )}
                    </div>
                    </Tooltip>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default QueueTeamTable;
